import { CheckOutlined } from "@ant-design/icons";
import { Table } from "antd";
import styled from "styled-components";

export const StyledTable = styled(Table)`
    width: 100%;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    overflow: hidden;

    .ant-table-container {
        border-top: none !important;
    }

    .ant-table-wrapper,
    .ant-table,
    .ant-table-container {
        border-radius: 0px !important;
    }

    .ant-table-thead {
        th {
            border-radius: 0px !important;
        }
        tr:last-child {
            display: none;
        }
    }

    .ant-table {
        background: transparent;
    }

    .ant-table-thead > tr > th {
        background-color: transparent;

        text-align: center;
        padding: 7px;
        font-weight: 400;
        font-size: 12px;
        line-height: 130%;
        text-align: center;
        color: ${(props) => props.theme.primaryTypographyColor};
    }

    .ant-table-tbody > tr > td {
        padding: 12px;
        background-color: transparent;

        font-weight: 400;
        font-size: 12px;
        line-height: 130%;
        color: ${(props) => props.theme.primaryTypographyColor};
    }

    .ant-table-tbody > tr:last-child > td {
        border-bottom: none;
    }
`;

export const RowCell = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
`;

export const CheckIcon = styled(CheckOutlined)<{ $active: boolean }>`
    color: ${({ $active, theme }) =>
        $active ? theme.successTypographyColor : theme.secondaryBorderColor};
`;
